import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=6f67fd31&scoped=true"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"
import style0 from "./Download.vue?vue&type=style&index=0&id=6f67fd31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f67fd31",
  null
  
)

export default component.exports